module.exports = __webpack_public_path__ + "static/media/logoLight.cdb8410b.png";